import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { Table, Tooltip, OverlayTrigger, Button } from 'react-bootstrap'
import ProcessingAgencyAssignationModal from '../../../containers/masters/ProcessingAgencyAssignation/ProcessingAgencyAssignationModalPage'
import IDocCarPagination from '../../commons/iDocCarPagination'
import SimpleTreeSelect from '../../commons/simpleForm/SimpleTreeSelect'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ProcessingAgencyAssignation extends PureComponent {
  constructor () {
    super()
    this.state = {
      uoId: null,
      filter: {
        searchUO: [],
        searchName: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchProcessingAgencyQuotaList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchProcessingAgencyQuotaList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (searchUO) {
    if (!searchUO || searchUO.length === 0) {
      this.setState({ filter: { ...this.state.filter, searchUO: null } }, () => this.searchProcessingAgency())
      return
    }
    let uos = []
    uos.push(searchUO)
    this.setState({ filter: { ...this.state.filter, searchUO: uos }, uoId: uos }, () => this.searchProcessingAgency())
  }

  handleNameChange (searchName) {
    if (this.state.filter.searchName !== searchName) {
      this.setState({ filter: { ...this.state.filter, searchName } })
    }
  }

  searchProcessingAgency () {
    this.props.actions.fetchProcessingAgencyQuotaList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  handleAddQuota () {
    if (this.state.filter.searchUO.length > 0) {
      this.props.actions.openAddProcessingAgencyAssignationModalSuccess(this.state.filter.searchUO[0])
    }
  }

  render () {
    const {
      t, quotaList, filter, pagesCount, quotasCount,
      filter: { page },
      combos: { UOTreeCombo },
      actions: { openEditProcessingAgencyAssignationModalSuccess, fetchProcessingAgencyQuotaList, deleteProcessingAgencyQuota }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'processingAgencyAssignationPage' })
    const tKey = 'MASTERS.PROCESSING_AGENCY_ASSIGNATION_QUOTA_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    return (
      <div id='processingAgencyAssignationMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            {(quotaList && quotaList.processingAgencies && quotaList.processingAgencies.length > 0) &&
              <Button
                className="_Btn new"
                onClick={() => this.handleAddQuota()}
                onKeyDown={(e) => handleKeyDown(e)}>
                <i className='iDocIcon-add-plus'></i> {t(`${tKey}ADD_BUTTON`)} {t(`${secMapMasters.title}`)}
              </Button>
            }

          </div>
          <div className='filters'>
            <div className="search-form">
              <div className='colWidth-100 marg-top-20'>
                <SimpleTreeSelect
                  colSm={4}
                  options={UOTreeCombo}
                  controlLabel={t(`${tKey}SEARCH_TITLE`)}
                  placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                  searchPlaceholder={t(`${tKey}ORGANIZED_UNIT`)}
                  value={this.state.filter.searchUO ? this.state.filter.searchUO.toString() : null}
                  onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {quotaList && quotaList.processingAgenciesQuotaGrouped && quotaList.processingAgenciesQuotaGrouped.map((agency, idx) => {
                return (
                  <Table className="editable-table" hover responsive>
                    <thead>
                      <tr>
                        <th onClick={() => { this.changeOrder('code') }}>
                          {t(`${tKey}ORGANIZED_UNIT`)}
                          <i className={this.getSortIcon('code')} />
                        </th>
                        <th onClick={() => { this.changeOrder('startDate') }}>
                          {t(`${tKey}START_DATE`)}
                          <i className={this.getSortIcon('startDate')} />
                        </th>
                        <th onClick={() => { this.changeOrder('endDate') }}>
                          {t(`${tKey}END_DATE`)}
                          <i className={this.getSortIcon('endDate')} />
                        </th>
                        <th className='actions'> {t(`${tKey}ACTIONS`)}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr key={idx}>
                        <td>{agency.organizedUnitName}</td>
                        <td>{agency.startDate}</td>
                        <td>{agency.endDate}</td>
                        <td className='actions'>
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openEditProcessingAgencyAssignationModalSuccess(agency, idx)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteProcessingAgencyQuota(agency)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                )
              })}
              {(!quotaList && quotaList.processingAgenciesQuotaGrouped === null || quotaList.processingAgenciesQuotaGrouped === undefined || quotaList.processingAgenciesQuotaGrouped.length === 0) &&
                <p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-users-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination
                    id="btn_pag_sales"
                    page={page}
                    pagesCount={pagesCount}
                    totalRows={quotasCount}
                    onSelectAction={(value) => fetchProcessingAgencyQuotaList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <ProcessingAgencyAssignationModal/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listAgenciesAssignation'
})(ProcessingAgencyAssignation)
